export default __webpack_public_path__ + "static/media/Luggage4.0a92924a.jpg";